import React from "react";
import styled from "styled-components";

const PageContainer = styled.div`
  min-height: 100vh;
  padding: 6rem 2rem 4rem;
  background: ${(props) => props.theme.colors.backgroundLight};
`;

const ContentWrapper = styled.div`
  max-width: 900px;
  margin: 0 auto;
  background: white;
  padding: 3rem;
  border-radius: 12px;
  box-shadow: ${(props) => props.theme.shadows.medium};

  @media (max-width: 768px) {
    padding: 2rem 1.5rem;
  }
`;

const Title = styled.h1`
  font-size: 2.5rem;
  color: ${(props) => props.theme.colors.primary};
  font-family: ${(props) => props.theme.fonts.heading};
  margin-bottom: 1rem;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const LastUpdated = styled.p`
  text-align: center;
  color: ${(props) => props.theme.colors.textLight};
  font-size: 0.9rem;
  margin-bottom: 2rem;
`;

const Section = styled.section`
  margin-bottom: 2.5rem;
`;

const SectionTitle = styled.h2`
  font-size: 1.5rem;
  color: ${(props) => props.theme.colors.textWarm};
  font-family: ${(props) => props.theme.fonts.heading};
  margin-bottom: 1rem;
  margin-top: 1.5rem;
`;

const Paragraph = styled.p`
  font-size: 1rem;
  line-height: 1.8;
  color: ${(props) => props.theme.colors.text};
  margin-bottom: 1rem;
`;

const List = styled.ul`
  margin-right: 2rem;
  margin-bottom: 1rem;
`;

const ListItem = styled.li`
  font-size: 1rem;
  line-height: 1.8;
  color: ${(props) => props.theme.colors.text};
  margin-bottom: 0.5rem;
`;

const TermsOfUse: React.FC = () => {
  return (
    <PageContainer>
      <ContentWrapper>
        <Title>תנאי שימוש</Title>
        <LastUpdated>עדכון אחרון: נובמבר 2024</LastUpdated>

        <Section>
          <SectionTitle>1. כללי</SectionTitle>
          <Paragraph>
            ברוכים הבאים לאתר של לי פרוינד - פסיכולוגית חינוכית. השימוש באתר זה
            כפוף לתנאי השימוש המפורטים להלן. השימוש באתר מהווה הסכמה מצדך
            לתנאים אלה. אם אינך מסכים לתנאים אלה, אנא הימנע משימוש באתר.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>2. שירותי האתר</SectionTitle>
          <Paragraph>
            אתר זה מספק מידע אודות שירותי ייעוץ פסיכולוגי-חינוכי, אבחונים
            פסיכו-חינוכיים וטיפול. המידע באתר מוצג למטרות אינפורמטיביות בלבד
            ואינו מהווה תחליף לייעוץ מקצועי אישי. לקביעת פגישה ולקבלת ייעוץ
            מקצועי, יש ליצור קשר ישיר.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>3. קניין רוחני</SectionTitle>
          <Paragraph>
            כל התכנים באתר זה, לרבות טקסט, עיצוב גרפי, לוגו, תמונות וקוד,
            הינם רכושה הבלעדי של לי פרוינד ומוגנים בזכויות יוצרים. אין להעתיק,
            לשכפל, להפיץ או להציג באופן פומבי כל חלק מהאתר ללא אישור מראש
            בכתב.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>4. פרטיות והגנת מידע</SectionTitle>
          <Paragraph>
            אנו מחויבים להגנה על פרטיותך. כל מידע אישי שיימסר לנו יישמר
            בסודיות מלאה ולא יועבר לצדדים שלישיים, אלא אם נדרש על פי חוק.
            השימוש במידע יהיה למטרות מקצועיות בלבד ובהתאם לחוקי הגנת הפרטיות
            וכללי האתיקה המקצועית של איגוד הפסיכולוגים בישראל.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>5. סודיות מקצועית</SectionTitle>
          <Paragraph>
            כפסיכולוגית חינוכית מורשית, אני כפופה לכללי הסודיות המקצועית כפי
            שנקבעו על ידי איגוד הפסיכולוגים בישראל. פרטי הלקוחות ומידע שנמסר
            במהלך הטיפול נשמרים בסודיות מוחלטת, פרט למקרים המחייבים דיווח על
            פי חוק.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>6. ביטול ושינוי פגישות</SectionTitle>
          <Paragraph>
            ביטול או שינוי פגישה יתאפשרו בהודעה של 24 שעות מראש. במקרה של ביטול
            באיחור, עלולה לחול חיוב עבור הפגישה. במקרה של אי הגעה ללא הודעה
            מראש, יחויב התשלום המלא.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>7. אחריות מקצועית</SectionTitle>
          <Paragraph>
            השירותים הניתנים באתר זה מבוצעים בהתאם לסטנדרטים המקצועיים
            המקובלים ובהתאם לכללי האתיקה של איגוד הפסיכולוגים בישראל. עם זאת,
            תוצאות הטיפול תלויות במגוון גורמים ואין אחריות לתוצאה מסוימת.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>8. הגבלת אחריות</SectionTitle>
          <Paragraph>האתר מוצג "כמות שהוא". אנו לא נהיה אחראים עבור:</Paragraph>
          <List>
            <ListItem>
              נזקים ישירים או עקיפים הנובעים משימוש או אי-שימוש באתר
            </ListItem>
            <ListItem>
              תקלות טכניות, שיבושים או הפסקות בפעילות האתר
            </ListItem>
            <ListItem>
              שגיאות או אי דיוקים במידע המוצג באתר
            </ListItem>
          </List>
        </Section>

        <Section>
          <SectionTitle>9. קישורים לאתרים חיצוניים</SectionTitle>
          <Paragraph>
            האתר עשוי לכלול קישורים לאתרים חיצוניים. אין לנו שליטה על תוכן
            אתרים אלה ואין אנו נושאים באחריות לתכנים או למדיניות הפרטיות שלהם.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>10. שינויים בתנאי שימוש</SectionTitle>
          <Paragraph>
            אנו שומרים לעצמנו את הזכות לעדכן ולשנות את תנאי השימוש מעת לעת.
            שינויים יכנסו לתוקף מיד עם פרסומם באתר. המשך שימוש באתר לאחר
            השינויים מהווה הסכמה לתנאים המעודכנים.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>11. דין וסמכות שיפוט</SectionTitle>
          <Paragraph>
            תנאי שימוש אלה כפופים לדיני מדינת ישראל. כל סכסוך הנוגע לשימוש באתר
            יידון אך ורק בבתי המשפט המוסמכים במדינת ישראל.
          </Paragraph>
        </Section>

        <Section>
          <SectionTitle>12. יצירת קשר</SectionTitle>
          <Paragraph>
            לשאלות או הבהרות בנוגע לתנאי השימוש, ניתן ליצור קשר בטלפון
            054-5954754 או במייל leefreund90@gmail.com.
          </Paragraph>
        </Section>
      </ContentWrapper>
    </PageContainer>
  );
};

export default TermsOfUse;
